module.exports = "pegasus/assets/classic-twitter.png";